/**
 * Máscaras BR para Contatos (Customers).
 */

export function digitsOnlyPhone(raw, max = 11) {
  return String(raw ?? '')
    .replace(/\D/g, '')
    .slice(0, max);
}

/** Telefone: 10 ou 11 dígitos — (XX)XXXX-XXXX / (XX)XXXXX-XXXX */
export function maskPhoneBr(value) {
  const d = digitsOnlyPhone(value, 11);
  if (!d) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)})${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)})${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)})${d.slice(2, 7)}-${d.slice(7)}`;
}

/** WhatsApp: 10 ou 11 dígitos — mesma máscara do telefone */
export function maskWhatsAppBr(value) {
  return maskPhoneBr(value);
}

export function isValidPhoneDigits(digits) {
  const d = digitsOnlyPhone(digits, 11);
  return d.length >= 10 && d.length <= 11;
}

export function isValidWhatsAppDigits(digits) {
  return isValidPhoneDigits(digits);
}
